import { object, string } from 'yup'

export const loginSchema = object({
    email: string().email("Informe um e-mail válido").required("E-mail é obrigatório"),
    password: string().min(6, "A senha deve conter no mínimo 6 caracteres").required("Senha é obrigatório")
})